import React from "react";
import { cn } from "../../lib/utils";

export function ExternalLinkIcon({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-4 w-4', className)}
      {...props}
    >
      <path 
        d="M8.33333 4.16667C7.87309 4.16667 7.5 4.53976 7.5 5C7.5 5.46024 7.87309 5.83333 8.33333 5.83333H12.9882L4.41074 14.411C4.08531 14.7364 4.08531 15.2636 4.41074 15.5891C4.73618 15.9145 5.26382 15.9145 5.58926 15.5891L14.1667 7.01175V11.6667C14.1667 12.1269 14.5398 12.5 15 12.5C15.4602 12.5 15.8333 12.1269 15.8333 11.6667V5C15.8333 4.53976 15.4602 4.16667 15 4.16667H8.33333Z" 
        fill="currentColor"
      />
    </svg>
  );
} 
